<ng-container *ngIf="viewModel$ | async as viewModel">
  <mat-card appearance="outlined" class="mat-elevation-z0">
    <mat-card-content fxLayout="column">
      <div class="content-wrapper">

        <!-- 80% MAIN CONTENT -->
        <div class="main-content">

          <!-- Title -->
          <h2>Versions for {{viewModel.event.EventName}}</h2>

          <!-- Actions bar -->
          <form [formGroup]="filtersForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px" fxLayout.lt-md="column"
              fxLayoutAlign.lt-md="start stretch" fxLayoutGap.lt-md="4px" class="actions-bar">

              <!-- Left Section (New Version, Actions, Search) -->
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlex>
                <button type="button" mat-raised-button color="accent" matTooltip="Add new record"
                  (click)="goToDetails('0')">
                  <fa-icon [icon]="['fas', 'plus']"></fa-icon> New Version
                </button>

                <!-- Actions button: always visible; View Details/Delete only apply when versions are selected -->
                <button type="button" mat-raised-button
                  [matMenuTriggerFor]="menu" matTooltip="Actions">
                  <mat-icon>more_vert</mat-icon> Actions
                </button>

                <mat-menu #menu="matMenu">
                  <!-- View Details -->
                  <button type="button" mat-menu-item *ngIf="getSelectedSectionRecords(versions).length === 1"
                    (click)="goToDetails(getSelectedSectionRecords(versions)[0].Id)">
                    <fa-icon [icon]="['fas', 'pen-to-square']"></fa-icon> View Details
                  </button>

                  <!-- Download -->
                  <button type="button" mat-menu-item [matMenuTriggerFor]="downloadMenu">
                    <mat-icon>arrow_circle_down</mat-icon> Download
                  </button>

                  <button type="button" mat-menu-item *ngIf="getSelectedSectionRecords(versions).length > 0"
                    (click)="deleteSelectedVersions()">
                    <fa-icon [icon]="['fas', 'trash']"></fa-icon> Delete
                  </button>
                  <!-- Selected count -->
                  <button type="button" mat-menu-item *ngIf="getSelectedSectionRecords(versions).length > 0">
                    {{ getSelectedSectionRecords(versions).length }} Selected
                  </button>
                </mat-menu>

                <mat-menu #downloadMenu="matMenu">
                  <button type="button" mat-menu-item [matMenuTriggerFor]="csvMenu">CSV</button>
                </mat-menu>

                <mat-menu #csvMenu="matMenu">
                  <button type="button" mat-menu-item (click)="exportAllVersions()">Export All</button>
                  <button type="button" mat-menu-item [disabled]="getSelectedSectionRecords(versions).length === 0"
                    (click)="exportSelectedVersions()">Export Selected</button>
                </mat-menu>

                <!-- Search -->
                <mat-form-field appearance="outline" class="mat-form-field-no-padding">
                  <mat-icon matPrefix>search</mat-icon>
                  <mat-label>Search</mat-label>
                  <input matInput type="text" placeholder="Search" (input)="onSearch($event)" formControlName="search"
                    #searchInput />
                  <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
                    (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <!-- Right Section (Sort & Filter) -->
              <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
                <button type="button" mat-button color="primary" (click)="openVersionSearchDialog(viewModel.totalRecords)">
                  <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon> Versions Search
                </button>
                <button type="button" mat-stroked-button color="primary" (click)="openSortDialog()">
                  <fa-icon [icon]="['fas', 'arrow-up']"></fa-icon>Sort
                </button>
              </div>
            </div>
          </form>

          <!-- Select all -->
          <div *ngIf="versions.length > 0" class="select-all-bar">
            <mat-checkbox
              [checked]="isAllVersionsSelected()"
              [indeterminate]="getSelectedSectionRecords(versions).length > 0 && !isAllVersionsSelected()"
              (change)="selectAllVersions($event.checked)">
              Select All
            </mat-checkbox>
          </div>

          <!-- Versions Grid with sidenav -->
          <mat-sidenav-container>
            <!-- Main content -->
            <mat-sidenav-content>
              <ng-container *ngIf="versions.length > 0; else noResults">
                <div class="versions-grid">
                  <mat-card *ngFor="let version of versions; let i = index; trackBy: trackById" class="version-card"
                    cdkDropList [id]="'version-' + i" [cdkDropListData]="version.stores"
                    [cdkDropListConnectedTo]="connectedLists" (cdkDropListDropped)="drop($event, version)">

                    <mat-progress-bar diameter="20" mode="indeterminate" *ngIf="version.isLoading" class="loading-bar"></mat-progress-bar>

                    <div class="version-header">
                      <mat-checkbox [checked]="version.selected"
                        (change)="selectVersion(version, $event.checked)"></mat-checkbox>
                      <h3>{{ version.VersionName }}</h3>

                      <button type="button" *ngIf="getSelectedStoreRecords(version).length > 0" mat-icon-button class="actions-btn"
                        [matMenuTriggerFor]="storeMenu">
                        <mat-icon>more_vert</mat-icon>
                      </button>

                      <mat-menu #storeMenu="matMenu">
                        <button type="button" mat-menu-item (click)="moveToNewVersion(version)">
                          <fa-icon [icon]="['fas', 'arrows-up-down-left-right']"></fa-icon> Move To New Version
                        </button>
                        <button type="button" mat-menu-item (click)="moveToOtherVersion(version)">
                          <fa-icon [icon]="['fas', 'arrows-up-down-left-right']"></fa-icon> Move To Existing Version
                        </button>
                        <button type="button" mat-menu-item (click)="disAssociateStore(version)">
                          <fa-icon [icon]="['fas', 'trash']"></fa-icon> Delete
                        </button>
                        <button type="button" mat-menu-item>
                          {{ getSelectedStoreRecords(version).length }} Selected
                        </button>
                      </mat-menu>
                    </div>

                    <div class="empty-placeholder" *ngIf="version.hasError">Failed to load.<button type="button"
                        mat-raised-button color="accent" matTooltip="Retry"
                        (click)="reloadVersion(version)">Retry</button></div>

                    <ng-container *ngIf="!version.hasError">
                      <div class="stores-count">
                        Stores ({{ version.stores.length }} / {{ version.storesCount ?? 0 }})
                        <a class="add-store-link" (click)="onAddStores(version.Id)">+ Add Stores</a>
                      </div>

                      <div *ngIf="!version.isLoading && version?.stores?.length === 0" class="empty-placeholder">
                        Add/Drop stores here
                      </div>

                      <!-- Scrollable stores container -->
                      <div class="stores-container" *ngIf="(version.stores ?? []).length > 0">
                        <div *ngFor="let store of version.stores; trackBy: trackByStoreId" class="store-item" cdkDrag>
                          <span class="drag-handle" cdkDragHandle>⋮⋮</span>
                          <mat-checkbox [(ngModel)]="store.selected"></mat-checkbox>
                          <span class="store-title">{{ store.StoreName }}</span>
                          <button class="remove-store-btn" (click)="removeStore(version, store)">
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                        <!-- Load More / Load All -->
                        <div class="load-more-wrapper" *ngIf="hasMoreStores(version)">
                          <ng-container *ngIf="!version.isLoading">
                            <a class="add-store-link" (click)="loadMoreStores(version)">Load More</a>
                            <!-- <span class="load-actions-separator">|</span>
                            <a class="add-store-link" (click)="loadAllStores(version)">Load All</a> -->
                          </ng-container>
                          <span class="loading-text" *ngIf="version.isLoading">Loading...</span>
                        </div>

                      </div>
                    </ng-container>

                  </mat-card>
                </div>
              </ng-container>
              <ng-template #noResults>
                <div class="no-results">
                  <mat-icon color="warn">info</mat-icon>
                  <p>No versions or stores match your filters.</p>
                </div>
              </ng-template>
            </mat-sidenav-content>
          </mat-sidenav-container>

        </div>

        <ng-container *ngIf="hideUnassignedPanel">
          <!-- COLLAPSED TOGGLE -->
          <div class="unassigned-toggle"
            *ngIf="((storesViewModel$ | async)?.totalRecords ?? 0) > 0 && !showUnassignedPanel"
            (click)="showUnassignedPanel = true">
            <fa-icon [icon]="['fas', 'store']"></fa-icon>
            <span class="count">{{ (storesViewModel$ | async)?.totalRecords }}</span>
            <mat-icon>chevron_right</mat-icon>
          </div>

          <!-- 20% UNASSIGNED PANEL -->
          <div class="unassigned-section" *ngIf="showUnassignedPanel">
            <mat-card class="unassigned-panel" cdkDropList id="unassigned"
              [cdkDropListData]="(storesViewModel$ | async)?.unassignedStores || []"
              [cdkDropListConnectedTo]="connectedLists" (cdkDropListDropped)="drop($event)">

              <div class="unassigned-header">
                <fa-icon [icon]="['fas', 'store']"></fa-icon>
                Unassigned Stores
                <span class="count">
                  {{ (storesViewModel$ | async)?.totalRecords }} Stores Available
                </span>
                <button mat-icon-button class="close-btn" (click)="showUnassignedPanel = false">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>

              <!-- Empty state -->
              <div *ngIf="(storesViewModel$ | async)?.unassignedStores?.length === 0" class="empty-placeholder">
                No stores available
              </div>

              <!-- Scrollable Store list -->
              <div class="unassigned-scroll">
                <div *ngFor="let store of (storesViewModel$ | async)?.unassignedStores" class="store-item" cdkDrag>
                  <span class="drag-handle" cdkDragHandle>⋮⋮</span>
                  <span class="store-title">{{ store.StoreName }}</span>
                </div>
              </div>

              <ng-container *ngIf="storesViewModel$ | async as vm">
                <div class="load-more-wrapper" *ngIf="(vm.unassignedStores?.length ?? 0) < (vm.totalRecords ?? 0)">
                  <button mat-stroked-button color="load-more-btn" (click)="loadMoreUnassignedStores(vm.page)">
                    Load More...
                  </button>
                </div>
              </ng-container>
            </mat-card>
          </div>
        </ng-container>
      </div>
    </mat-card-content>

    <mat-card-actions fxLayout="row" fxLayoutAlign="space-between" gdAlignRows="end">
      <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.page.pageSize"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 500]" (page)="onPage($event)" *ngIf="viewModel.versions.length"
        showFirstLastButtons [pageIndex]="viewModel.page.pageIndex">
      </mat-paginator>
    </mat-card-actions>
  </mat-card>
</ng-container>